export default "__VITE_ASSET__CgUm6LnS__"